import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    padding-inline: ${spacing(2)};
  `,
  image: css`
    height: 24px;
  `,
  pill: css`
    flex-shrink: 0;
    background-color: var(--colorScheme-controlMinor, rgba(245, 244, 242, 0.1)) !important;
    border-radius: 32px !important;
    padding-block: 4px !important;
    padding-inline: 14px !important;
    block-size: 28px !important;
    white-space: nowrap;
  `,
  pillText: css`
    color: var(--colorScheme-text, #000000);
  `,
}
